export default __webpack_public_path__ + "static/media/konstantin_l.a82ede45.jpg";